import { useUserStore } from '@/stores/userStore'

const BASE_URL = import.meta.env.VITE_PYTHON_BASE_URL ?? 'https://ai-llm.yichenglink.com'

const getHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const { currentUser } = useUserStore.getState()
  if (currentUser?.memberToken) {
    headers['memberToken'] = currentUser.memberToken
  }
  return headers
}

async function request<T>(path: string, params?: Record<string, unknown>): Promise<T> {
  const url = new URL(BASE_URL + path)
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.set(k, String(v))
    })
  }
  const res = await fetch(url.toString(), { headers: getHeaders() })
  const json = await res.json()
  if (json.code !== 200) throw new Error(json.msg ?? '请求失败')
  return json.data as T
}

export const agentFetcher = {
  get: <T>(path: string, params?: Record<string, unknown>) => request<T>(path, params),
}
